export type CatalogPreviewResult = {
  key: string;
  value: Record<string, unknown>;
};

export enum SubmitType {
  preview = 'preview',
  apply = 'apply',
}
